import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { FileSpreadsheet, Radio, Sparkles, UserPlus } from "lucide-react";

const METRICS = [
  { k: "invoices_this_month",     label: "Sale invoices · this month", icon: FileSpreadsheet },
  { k: "gsp_api_calls",           label: "GST/GSP API calls",          icon: Radio },
  { k: "ai_credits_used",         label: "AI credits used",            icon: Sparkles },
  { k: "users_added_this_month",  label: "Users added · this month",   icon: UserPlus },
];

/**
 * Company Admin — read-only view of the org's usage counters for the
 * current calendar month.
 */
export default function UsageMetricsTab() {
  const [m, setM] = useState(null);
  useEffect(() => {
    api.get("/usage-metrics/me").then(r => setM(r.data)).catch(() => setM({}));
  }, []);
  if (!m) return <div className="text-sm text-muted-foreground">Loading usage…</div>;

  return (
    <div className="space-y-4" data-testid="usage-metrics-tab">
      <div>
        <div className="text-[10px] font-mono uppercase tracking-widest text-accent">// Your usage</div>
        <div className="text-sm text-muted-foreground mt-1">
          Live counters for <b>{m.month}</b>. Lifetime totals shown in italics.
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {METRICS.map(({ k, label, icon: Icon }) => (
          <Card key={k} className="p-4 rounded-sm border" data-testid={`usage-me-${k}`}>
            <div className="flex items-center justify-between">
              <div className="text-[10px] font-mono uppercase text-muted-foreground">{label}</div>
              <Icon className="w-4 h-4 text-accent" />
            </div>
            <div className="text-3xl font-bold mt-2">{(m[k] || 0).toLocaleString("en-IN")}</div>
            {k === "invoices_this_month" && (
              <div className="text-[11px] text-muted-foreground italic mt-1">
                {(m.invoices_total || 0).toLocaleString("en-IN")} lifetime
              </div>
            )}
            {k === "users_added_this_month" && (
              <div className="text-[11px] text-muted-foreground italic mt-1">
                {(m.users_total || 0).toLocaleString("en-IN")} total
              </div>
            )}
          </Card>
        ))}
      </div>

      <div className="text-[11px] text-muted-foreground">
        <b>GSP calls</b> counts every GST portal request made through Zenith360-GST or NIC. <b>AI credits</b> counts every LLM query (Ask-AI, Help Center suggestions).
      </div>
    </div>
  );
}
